import {gql} from 'apollo-angular';

export function retrieveCareerProfilesBySectorId(fields: string[]) {
  return gql`
    query retrieveCareerProfilesBySectorId($sectorId: String!, $page: Int!, $size: Int!) {
      retrieveCareerProfilesBySectorId(sectorId: $sectorId, page: $page, size: $size) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveCareerProfileById(fields: string[]) {
  return gql`
    query retrieveCareerProfileById($id: String!) {
      retrieveCareerProfileById(id: $id) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function createCareerProfile(fields: string[]) {
  return gql`
    mutation createCareerProfile($careerProfile: CareerProfileDto!) {
      createCareerProfile(careerProfile: $careerProfile) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function updateCareerProfile(fields: string[]) {
  return gql`
    mutation updateCareerProfile($careerProfile: CareerProfileDto!) {
      updateCareerProfile(careerProfile: $careerProfile) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveCareerProfilesBySectorIdAndCompanyId(fields: string[]) {
  return gql`
    query retrieveCareerProfilesBySectorIdAndCompanyId($sectorId: String!, $companyId: String!, $size: Int!, $includeId: String) {
      retrieveCareerProfilesBySectorIdAndCompanyId(sectorId: $sectorId, companyId: $companyId, size: $size, includeId: $includeId) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveCareerProfilesByQuery(fields: string[]) {
  return gql`
    query retrieveCareerProfilesByQuery($query: String!, $sectorId: String!, $companyId: String!, $size: Int!) {
      retrieveCareerProfilesByQuery(query: $query, sectorId: $sectorId, companyId: $companyId, size: $size) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function retrieveCareerProfilesByIds(fields: string[]) {
  return gql`
    query retrieveCareerProfilesByIds($ids: [String]!) {
      retrieveCareerProfilesByIds(ids: $ids) {
        ${fields.join('\n')}
      }
    }
  `;
}

export function removeCareerProfile() {
  return gql`
    mutation removeCareerProfile($id: String!) {
      removeCareerProfile(id: $id)
    }
  `;
}
